import { ModuleTypes } from 'dashboard/apps/DashboardLayoutEditor/constants';
import { BaseModule } from 'dashboard/lib/module';

export interface ModuleKeyValue extends BaseModule {
  type: ModuleTypes.KeyValue;
  'display-format': KeyValueModuleDisplayFormat;
  title: string;
  'key-label'?: string;
  'value-label'?: string;
  'preview-data': KeyValueData;
  'field-key': string;
}

export enum KeyValueModuleDisplayFormat {
  Grid = 'grid',
  Table = 'table',
}

// [chris] My hunch is that this will make it easier to migrate if we ever decide to support non-string value display.
// e.g. Once we get custom fields, these fields can have their own toString methods supported.
export interface KeyValueData extends Record<string, string> {}
